/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbAnneeScolaireDto
 */
export interface FcbAnneeScolaireDto {
    /**
     * 
     * @type {string}
     * @memberof FcbAnneeScolaireDto
     */
    idanneeScolaire?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbAnneeScolaireDto
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FcbAnneeScolaireDto
     */
    dateDebut?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof FcbAnneeScolaireDto
     */
    dateFin?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbAnneeScolaireDto
     */
    actif?: boolean | null;
}

/**
 * Check if a given object implements the FcbAnneeScolaireDto interface.
 */
export function instanceOfFcbAnneeScolaireDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbAnneeScolaireDtoFromJSON(json: any): FcbAnneeScolaireDto {
    return FcbAnneeScolaireDtoFromJSONTyped(json, false);
}

export function FcbAnneeScolaireDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbAnneeScolaireDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idanneeScolaire': !exists(json, 'idanneeScolaire') ? undefined : json['idanneeScolaire'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'dateDebut': !exists(json, 'dateDebut') ? undefined : (json['dateDebut'] === null ? null : new Date(json['dateDebut'])),
        'dateFin': !exists(json, 'dateFin') ? undefined : (json['dateFin'] === null ? null : new Date(json['dateFin'])),
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
    };
}

export function FcbAnneeScolaireDtoToJSON(value?: FcbAnneeScolaireDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idanneeScolaire': value.idanneeScolaire,
        'description': value.description,
        'dateDebut': value.dateDebut === undefined ? undefined : (value.dateDebut === null ? null : value.dateDebut.toISOString()),
        'dateFin': value.dateFin === undefined ? undefined : (value.dateFin === null ? null : value.dateFin.toISOString()),
        'actif': value.actif,
    };
}

